import React from 'react'
import classnames from 'classnames/bind'
import PopupTooltip from '../../overlays/popupTooltip'
import { ColorHash } from '../../../utils'
import styles from './styles.scss'

const cx = classnames.bind(styles)

const colorHash = new ColorHash()

interface InitialsAvatarProps {
  initials: string
  size?: 'x-small' | 'small' | 'medium' | 'large'
  backgroundColor?: string
  identifier?: string
  tooltipContent?: React.ReactNode
  onClick?: () => void
  className?: string
  position?:
    | 'top left'
    | 'top center'
    | 'top right'
    | 'bottom left'
    | 'bottom center'
    | 'bottom right'
    | 'right center'
    | 'left center'
  whiteBackground?: boolean
}

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  initials,
  size = 'medium',
  backgroundColor,
  identifier,
  tooltipContent,
  onClick,
  className,
  position = 'top center',
  whiteBackground = false,
}) => {
  const avatarClasses = cx(
    'initials-avatar',
    size,
    { clickable: !!onClick },
    className
  )

  const avatarStyle: React.CSSProperties = {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    backgroundColor:
      backgroundColor ||
      (identifier || initials
        ? colorHash.hex(identifier || initials)
        : '#6c757d'),
    cursor: onClick ? 'pointer' : 'default',
  }

  const avatar = (
    <div
      className={avatarClasses}
      style={avatarStyle}
      aria-label={tooltipContent ? `Avatar for ${initials}` : initials}
      data-elm-id={`initials-avatar-${initials}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {initials}
    </div>
  )

  return tooltipContent ? (
    // @ts-ignore next
    <PopupTooltip
      trigger={avatar}
      position={position}
      hoverable
      hideOnScroll
      whiteBackground={whiteBackground}
    >
      <div className={cx('tooltip-content')}>{tooltipContent}</div>
    </PopupTooltip>
  ) : (
    avatar
  )
}

export default InitialsAvatar
